import { connect } from 'react-redux';
import { DealRentDescription } from './DealRentDescription';
import { prefetchFormState } from '../../store/deal-rent';
import { IState } from '../../store';

export function mapStateToProps(state: IState) {
  return {
    id: state.offerData.offer.id,
  };
}

export const DealRentDescriptionV1Container = connect(mapStateToProps, { openModal: prefetchFormState })(
  DealRentDescription,
);
